import { createSlice } from "@reduxjs/toolkit";
import MicSensitivity from "src/modules/station/enums/MicSensitivity";

const initialState = {
  micSensitivity: MicSensitivity.MS_MEDIUM.id,
  micSensitivityCorrection: 0,
  motionSensitivity: "MD_OFF"
};

const babyStationSlice = createSlice({
  initialState,
  name: "babyStation",
  reducers: {
    setMicSensitivity(state, { payload }) {
      state.micSensitivity = payload;
    },
    changeMotionSensitivity(state, { payload }) {
      state.motionSensitivity = payload;
    },
    setMicSensitivityCorrection(state, { payload }) {
      state.micSensitivityCorrection = payload;
    }
  }
});

export { babyStationSlice };
export default babyStationSlice.reducer;
